<template>
	<ul class="aiProCont" :key="componentKey">
		<li v-for="(template, index) in templates" :key="template.id || index" class="aiProContBox">
			<div class="aiProTop">
				<div class="num">NO.{{ index+1 }}</div>
				<div class="pro_name">
					{{ template.options && template.detail ? template.options + ' + ' + template.detail : 'SELECT OPTIONS' }}
				</div>
				<div class="remake">
					<input type="checkbox" :name="'remake_' + (index+1)" :id="'remake_' + (index+1)" class="chk"
							value="remake" true-value="remake" v-model="template.remake"
							@change="emitRemakeCount" />
					<label :for="'remake_' + (index+1)"><span>리메이크</span></label>
				</div>
				<div class="pro_delete" @click="remove_template(index)">삭제</div>
			</div>

			<div class="aiProBottom">
				<div class="form-row">
					<div class="form-group w50">
						<label :for="'options_' + (index+1)" class="form-label">의뢰보철물 선택</label>
						<select class="form-control options" :id="'options_' + (index+1)" :name="'options_' + (index+1)"
								v-model="template.options" @change="updateDetails(index)" required="">
							<option value="">선택하세요</option>
							<option v-for="(details, option) in groupedData" :key="option" :value="option">
								{{ option }}
							</option>
						</select>
					</div>

					<div class="form-group w50">
						<label :for="'detail_' + (index+1)" class="form-label">상세 선택</label>
						<select class="form-control detail" :id="'detail_' + (index+1)" :name="'detail_' + (index+1)"
								v-model="template.detail" @change="updateProsthesisName(index)" required="">
							<option value="">선택하세요</option>
							<option v-for="detail in template.details" :key="detail" :value="detail">
								{{ detail }}
							</option>
						</select>
					</div>
				</div>

				<div v-if="favoriteData.length > 0" class="form-row">
					<div class="form-group">
						<label class="form-label">보철 즐겨찾기</label>
						<ul class="favoriteBtn">
							<li v-for="fav in favoriteData" :key="fav.id" @click="setFavorite(index, fav.options, fav.detail)">
								<p>{{ fav.options }} + {{ fav.detail }}</p>
							</li>
						</ul>
					</div>
				</div>

				<div class="form-row">
					<div class="form-group">
						<label class="form-label">치식</label>
						<div class="teethWrap">
							<ul class="teethTab">
								<li id="upper-tab" @click="handleTeethClick($event, index, 'upper')">상악</li>
								<li id="all-tab" @click="handleTeethClick($event, index, 'all')">전악</li>
								<li id="lower-tab" @click="handleTeethClick($event, index, 'lower')">하악</li>
							</ul>

							<div class="teeth">
								<div class="r_teeth r_teeth1">
									<label v-for="value in [18, 17, 16, 15, 14, 13, 12, 11]" :key="value"
										:id="'r_teeth_check' + value + '_' + (index+1)" :data-idx="index"
										@click="handleTeethClick($event, index, value)" :class="{ 'active': isActive(index, value) }">
										{{ value }}
										<input type="checkbox" :name="'teeth_' + (index+1) + '[]'" :value="value"
											@change="updateTeethArray(index, value)" :checked="isActive(index, value)" style="display: none;">
									</label>
								</div>
								<div class="r_teeth r_teeth2">
									<label v-for="value in [21, 22, 23, 24, 25, 26, 27, 28]" :key="value"
										:id="'r_teeth_check' + value + '_' + (index+1)" :data-idx="index"
										@click="handleTeethClick($event, index, value)" :class="{ 'active': isActive(index, value) }">
										{{ value }}
										<input type="checkbox" :name="'teeth_' + (index+1) + '[]'" :value="value"
											@change="updateTeethArray(index, value)" :checked="isActive(index, value)" style="display: none;">
									</label>
								</div>
								<div class="r_teeth r_teeth3">
									<label v-for="value in [48, 47, 46, 45, 44, 43, 42, 41]" :key="value"
										:id="'r_teeth_check' + value + '_' + (index+1)" :data-idx="index"
										@click="handleTeethClick($event, index, value)" :class="{ 'active': isActive(index, value) }">
										{{ value }}
										<input type="checkbox" :name="'teeth_' + (index+1) + '[]'" :value="value"
											@change="updateTeethArray(index, value)" :checked="isActive(index, value)" style="display: none;">
									</label>
								</div>
								<div class="r_teeth r_teeth4">
									<label v-for="value in [31, 32, 33, 34, 35, 36, 37, 38]" :key="value"
										:id="'r_teeth_check' + value + '_' + (index+1)" :data-idx="index"
										@click="handleTeethClick($event, index, value)" :class="{ 'active': isActive(index, value) }">
										{{ value }}
										<input type="checkbox" :name="'teeth_' + (index+1) + '[]'" :value="value"
											@change="updateTeethArray(index, value)" :checked="isActive(index, value)" style="display: none;">
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="form-row">
					<div class="form-group">
						<label :for="'memo_' + (index+1)" class="form-label">메모</label>
						<textarea :name="'memo_' + (index+1)" :id="'memo_' + (index+1)" v-model="template.memo"
							placeholder="의뢰 보철물 관련 메모 입력">{{ templates[`memo_${index}`] }}</textarea>
					</div>
				</div>
			</div>
		</li>
	</ul>
	<div class="plusBtn" :class="{ 'disabled': templates.prosthesis_cnt >= 5 || templates.length >= 5 }" @click="add_template"><span class="plus_icon"></span>항목추가</div>
</template>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { toRaw } from 'vue';
import { onMounted, ref, computed, watch } from 'vue';
import * as globaljs from '@/components/utils/global';
import * as aiorderjs from '@/components/utils/aiorder';

// Props
const props = defineProps({
	modelValue: {
		type: Array,
		required: true
	},
	other_id: {
		type: String,
		required: true
	},
	isNew: {
		type: Boolean,
		required: false
	}
});

const componentKey = ref(0);

const forceUpdate = () => {
	componentKey.value += 1;
	console.log("Force update triggered.");
};

const emit = defineEmits(['update:modelValue', 'update-remake-count', 'update-source']);

// 240822 templates를 배열로 초기화
// 1. 배열로 초기화
const templates = ref(Array.isArray(props.modelValue) ? props.modelValue : []);

// 240822 기존의 modelValue를 templates 배열로 변환
// 2. templates.value가 배열인지 확인
watch(() => props.modelValue, (newVal) => {
if (Array.isArray(newVal)) {
	templates.value = newVal;
}
}, { deep: true });

watch(() => templates.value, (newVal) => {
console.log("Templates updated:", newVal);
	checkTeethStatus(); // templates가 업데이트되면 teeth 상태를 반영
}, { deep: true });



let updatingFromEmit = false; // 플래그 변수

// 240822 Vue에 반영
const update = () => {
	if (updatingFromEmit) return;

	// map을 이용해 templates.value의 요소들을 배열로 변환합니다.
	const updatedValue = templates.value.map((item) => ({
		options: item.options,
		detail: item.detail,
		details: item.details,
		remake: item.remake,
		memo: item.memo, // 메모 필드 추가
		teeth: item.teeth  // 치식 필드 추가
	}));

	console.log('Emitting updatedValue:', updatedValue);
	updatingFromEmit = true;

	// emit에서 배열을 보내도록 수정
	emit('update:modelValue', updatedValue);

	updatingFromEmit = false;
};

const emitRemakeCount = () => {
	const remakeCount = templates.value.filter(item => item.remake === 'remake').length;
	emit('update-remake-count', remakeCount);
};

const emitSource = () => {
	emit('update-source', source.value);
};

const updateTeethArray = (index, value) => {
	const currentTeeth = templates.value[index].teeth;

	if (currentTeeth.includes(value)) {
		// 이미 존재하는 경우 제거
		templates.value[index].teeth = currentTeeth.filter(v => v !== value);
	} else {
		// 존재하지 않으면 추가
		templates.value[index].teeth.push(value);
	}

	// 변경 사항을 부모로 반영
	update();
};

const updateTabActiveState = (index) => {
	const template = templates.value[index];

	// 상악 치아들
	const upperTeeth = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28].map(t => t.toString());
	// 하악 치아들
	const lowerTeeth = [48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38].map(t => t.toString());
	// 전악 치아들 (상악 + 하악)
	const allTeeth = upperTeeth.concat(lowerTeeth);

	// 상악 탭
	const upperTab = document.querySelector('#upper-tab'); // 상악 탭의 ID 또는 클래스로 선택
	const lowerTab = document.querySelector('#lower-tab'); // 하악 탭
	const allTab = document.querySelector('#all-tab'); // 전악 탭

	// 상악 치아가 모두 선택된 경우 상악 탭에 active 클래스 추가
	const allUpperSelected = upperTeeth.every(teeth => template.teeth.includes(teeth));
	if (allUpperSelected) {
		upperTab.classList.add('active');
	} else {
		upperTab.classList.remove('active');
	}

	// 하악 치아가 모두 선택된 경우 하악 탭에 active 클래스 추가
	const allLowerSelected = lowerTeeth.every(teeth => template.teeth.includes(teeth));
	if (allLowerSelected) {
		lowerTab.classList.add('active');
	} else {
		lowerTab.classList.remove('active');
	}

	// 전악 치아가 모두 선택된 경우 전악 탭에 active 클래스 추가
	const allSelected = allTeeth.every(teeth => template.teeth.includes(teeth));
	if (allSelected) {
		allTab.classList.add('active');
	} else {
		allTab.classList.remove('active');
	}
};

const handleTeethClick = (event, index, value) => {
	event.preventDefault();
	event.stopPropagation();

	const trg = event.target;
	const template = templates.value[index];

	// 탭 클릭 시 처리
	if (typeof value === 'string') {
		let teethToToggle = [];

		if (value === 'upper') {
			teethToToggle = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28];
		} else if (value === 'all') {
			teethToToggle = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28,
							48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38];
		} else if (value === 'lower') {
			teethToToggle = [48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38];
		}

		// teeth 배열이 숫자 배열인지, 문자열 배열인지 확인 후 처리
		const selectedTeeth = template.teeth.map(t => t.toString());

		const allSelected = teethToToggle.every(teeth => selectedTeeth.includes(teeth.toString()));

		if (allSelected) {
			// 모든 치아가 선택되어 있으면 해제
			template.teeth = template.teeth.filter(teeth => !teethToToggle.includes(parseInt(teeth)));
			trg.classList.remove('active');
		} else {
			// 선택되지 않은 치아를 추가 (중복 방지)
			template.teeth = Array.from(new Set([...selectedTeeth, ...teethToToggle.map(t => t.toString())]));
			trg.classList.add('active');
		}

	} else {
		// 개별 치아 클릭 시 처리
		trg.classList.toggle('active');
		let currentTeeth = template.teeth.map(t => t.toString());

		if (!currentTeeth.includes(value.toString())) {
			currentTeeth.push(value.toString());
		} else {
			currentTeeth = currentTeeth.filter(v => v !== value.toString());
		}

		template.teeth = Array.from(new Set(currentTeeth));
	}

	// 변경 사항을 부모 컴포넌트에 반영
	update();

	// 탭의 active 상태 업데이트
	updateTabActiveState(index);
};

// 보철물 선택 업데이트
const updateDetails = (index) => {
	const selectedOption = templates.value[index].options;
	if (groupedData.value[selectedOption]) {
		// 선택된 옵션에 따라 details를 업데이트
		templates.value[index].details = [...groupedData.value[selectedOption]];
	} else {
		// 선택된 옵션에 해당하는 details가 없으면 빈 배열 설정
		templates.value[index].details = [];
	}
	// 상세 선택이 가능한 경우 첫 번째 값을 기본 선택
	if (templates.value[index].details.length > 0 && !templates.value[index].detail) {
		templates.value[index].detail = templates.value[index].details[0];
	}
	// 치식 데이터가 변경될 수 있으므로 update() 호출
	update();
};

const updateProsthesisName = (index) => {
	update();
};

// 240822 추가된 항목을 배열에 추가
const add_template = () => {
	if (templates.value.length >= 5) return;

	templates.value.push({
		options: '',
		detail: '',
		details: [],
		remake: false,
		memo: '',
		teeth: []  // 2차원 배열 대신 단순 배열로 초기화
	});
	update();  // 부모에 반영
	checkTeethStatus();  // 추가 후 teeth 상태 업데이트
};

// 240822 특정 인덱스 항목을 삭제
const remove_template = (index) => {
	// 인덱스가 배열 범위 내에 있는지 확인
	if (index >= 0 && index < templates.value.length) {
		// 지정된 인덱스에서 항목 제거
		templates.value.splice(index, 1);

		// 나머지 템플릿 업데이트
		templates.value = templates.value.map((template) => {
			return {
				...template,
				options: template.options || '',
				detail: template.detail || '',
				details: [...template.details], // 깊은 복사
				remake: template.remake || false,
				memo: template.memo || '',
				teeth: [...template.teeth].filter(Boolean) || [] // 깊은 복사로 teeth 배열 업데이트 및 빈 값 제거
			};
		});

		// 변경 사항을 반영하기 위해 업데이트 함수 호출
		update();
		emitRemakeCount(); // 삭제 후에도 remake count를 업데이트
		checkTeethStatus();  // 추가 후 teeth 상태 업데이트
	} else {
		console.error('Invalid index: ', index);
	}
};

const source = ref('');
const items = ref([]);
const groupedData = ref([]);
const favoriteData = ref([]);

watch(
	() => items.value,
	(newVal) => {
		groupedData.value = newVal.reduce((acc, item) => {
			if (!acc[item.options]) {
				acc[item.options] = [];
			}
			acc[item.options].push(item.detail);
			return acc;
		}, {});

		favoriteData.value = newVal
			.filter(item => item.bookmark === 1)
			.map(item => ({
				id: item.id,
				options: item.options,
				detail: item.detail
			}));

		initializeSelections();
	}
);

const initializeSelections = () => {
	setTimeout(() => {
		templates.value.forEach((template, index) => {
			let rawTeethData = toRaw(template.teeth);

			if (rawTeethData && typeof rawTeethData === 'string') {
				// 쉼표로 분할하고 각 요소의 공백을 제거
				template.teeth = rawTeethData.split(',').map(t => t.trim());
			} else if (Array.isArray(rawTeethData)) {
				// 이미 배열이라면 그대로 사용
				template.teeth = rawTeethData;
			} else {
				// 기본 값 설정
				template.teeth = [];
			}

console.log(`Template ${index + 1} teeth:`, template.teeth);

			if (template.options) {
				updateDetails(index);
			}
			if (template.detail) {
				template.detail = template.detail;
			}

			// teeth 배열에 맞춰 각 치아 번호에 해당하는 체크박스 상태를 업데이트
			if (Array.isArray(template.teeth)) {
				template.teeth.forEach(teethNumber => {
					const labelElement = document.getElementById(`r_teeth_check${teethNumber}_${index + 1}`);
					if (labelElement) {
						const checkboxElement = labelElement.querySelector('input[type="checkbox"]');  // label 내부의 체크박스 선택
						if (checkboxElement) {
							checkboxElement.checked = true;  // teeth 배열에 있는 값을 체크
						}
						labelElement.classList.add('active');  // label에 active 클래스 추가
					}
				});
			}
		});
		update(); // 모든 초기화 작업 후 상태 업데이트
		checkTeethStatus(); // Teeth 상태를 다시 반영 (추가된 부분)
	}, 100);
};

const isActive = (index, value) => {
	// teeth 배열을 가져오기
	let teethArray = toRaw(templates.value[index].teeth);

	// teethArray가 문자열 배열이고, 각 요소가 쉼표로 구분된 경우 분할 및 공백 제거
	if (teethArray.length === 1 && typeof teethArray[0] === 'string') {
		if (teethArray[0].trim() !== '') {  // 빈 문자열이 아닌 경우만 처리
			teethArray = teethArray[0].split(',').map(t => t.trim());
		}
	}

	// teethArray가 문자열인 경우 분할하여 처리
	if (typeof teethArray === 'string') {
		teethArray = teethArray.split(',').map(t => t.trim());
	}

	// teethArray가 배열이고 값이 포함되어 있으면 true 반환
	return Array.isArray(teethArray) && teethArray.includes(value.toString());
};

const checkTeethStatus = () => {
	templates.value.forEach((template, index) => {
		// 모든 치아의 상태를 일단 해제 (초기화)
		const allTeeth = [
			18, 17, 16, 15, 14, 13, 12, 11,
			21, 22, 23, 24, 25, 26, 27, 28,
			48, 47, 46, 45, 44, 43, 42, 41,
			31, 32, 33, 34, 35, 36, 37, 38
		];

		allTeeth.forEach(teethValue => {
			const labelElement = document.getElementById(`r_teeth_check${teethValue}_${index + 1}`);
			if (labelElement) {
				const checkboxElement = labelElement.querySelector('input[type="checkbox"]');  // label 내부의 체크박스 선택
//console.log(`Checking element for teeth ${teethValue}:`, checkboxElement);
				if (checkboxElement) {
					checkboxElement.checked = false;  // 모든 체크박스를 해제
				}
				labelElement.classList.remove('active');  // label의 active 클래스 제거
			}
		});

		// `isActive()`를 사용해 teeth 배열에 맞는 체크박스를 다시 체크
		template.teeth.forEach(teethValue => {
			const labelElement = document.getElementById(`r_teeth_check${teethValue}_${index + 1}`);
			if (labelElement) {
				const checkboxElement = labelElement.querySelector('input[type="checkbox"]');  // label 내부의 체크박스 선택
//console.log(`Activating element for teeth ${teethValue}:`, checkboxElement);
				if (checkboxElement) {
					checkboxElement.checked = true;  // teeth 배열에 있는 값을 체크
				}
				labelElement.classList.add('active');  // label에 active 클래스 추가
			}
		});

	});
};


const setFavorite = (index, options, detail) => {
	//console.log( templates.value[`options_${index}`] );
	//console.log( templates.value[`detail_${index}`] );
	// 240904 구조가 달라서 수정함
	templates.value[index].options = options;
	templates.value[index].detail = detail;
	updateDetails(index); // 옵션 변경 시 세부 항목을 업데이트
	update();
};

onMounted(async () => {
	aiorderjs.DOMLoaded();

	await getModels();

	if(props.isNew) {
		console.debug('props.isNew', props.isNew);
		// 240912 다시 막음 add_template(); // 240909 신규일때 처음에 한번
	}

	checkTeethStatus();
});

const getModels = async () => {
	const params = new URLSearchParams();
	params.append('acc_type', globaljs.acc_type);
	//params.append('mb_level', globaljs.mb_level);
	if (globaljs.acc_type === 'lab') {
		params.append('lab_id', globaljs.mb_boss_id);
		params.append('hos_id', props.other_id);
	} else {
		params.append('lab_id', props.other_id);
		params.append('hos_id', globaljs.mb_boss_id);
	}

	params.append('hide', 0);

	// URLSearchParams를 객체로 변환
	const object = {};
	params.forEach((value, key) => {
		if (key.endsWith('[]')) {
			const arrayKey = key.slice(0, -2);
			if (!object[arrayKey]) {
				object[arrayKey] = [];
			}
			object[arrayKey].push(value);
		} else {
			object[key] = value;
		}
	});

	// 결과 확인용 로그 출력
	const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
console.info(jsonString);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/prosthesis/sub`, { params });
console.debug(response.data.result);
		items.value = response.data.result.data;
		source.value = response.data.result.source;
		emitSource();
	} catch (error) {
console.error('Error getModels:', error);
	}
}
</script>